var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.41 12.59L9.83 8L14.41 3.41L13 2L7 8L13 14L14.41 12.59Z",
    fill: "#FB263B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41 12.59L3.83 8L8.41 3.41L7 2L1 8L7 14L8.41 12.59Z",
    fill: "#FB263B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstRed);
export default __webpack_public_path__ + "static/media/firstRed.ea2f8acdc26ffd7d5edf87e78961edcb.svg";
export { ForwardRef as ReactComponent };